import { Component, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PdfUtils } from 'src/app/shared/utils/pdf-utils';
import * as jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { LoaderService } from 'src/app/services/loader.service';
import { ObraDTO } from 'src/app/models/dtos/obra-dto';

@Component({
  selector: 'modal-carpeta-ejecutiva',
  templateUrl: './modal-carpeta-ejecutiva.component.html',
  styleUrls: ['./modal-carpeta-ejecutiva.component.scss']
})
export class ModalCarpetaEjecutivaComponent implements OnInit {

  @ViewChild('modalCarpetaEjecutiva')
  public modalCarpetaEjecutiva: any;
  public modalActivo: NgbModalRef;
  @Output()
  public guardarFormatoListener: EventEmitter<ObraDTO> = new EventEmitter<ObraDTO>();
  public obraSeleccionada: ObraDTO;
  public obras: ObraDTO[] = [];
  public boolCarpetaEjecutiva: boolean = true;
  public keysObras: any[] = [];

  constructor(
    private loaderService: LoaderService,
    private modalService: NgbModal,
    private pdfUtils: PdfUtils) { }

  ngOnInit() {
  }

  public descargar(): void {
    if (!this.boolCarpetaEjecutiva) {
      this.loaderService.activarLoaderScreen();
      let promesas: Promise<any>[] = [];
      let pdf = new jsPDF(
        'l', 'cm', 'letter', true
      );
      let width = pdf.internal.pageSize.getWidth();
      let height = pdf.internal.pageSize.getHeight();
      let configuracionCanvas = {
        allowTaint: true,
        useCORS: true,
        scale: 4
      };
      // IMPLEMENTACION ALTERNATIVA NO ELIMINAR
      // this.keysObras.forEach(
      //   (key: string) => {
      //     promesas.push(html2canvas(document.getElementById(`portada${key}`), configuracionCanvas));
      //     promesas.push(html2canvas(document.getElementById(`pdf${key}`), configuracionCanvas));
      //     promesas.push(html2canvas(document.getElementById(`pdfNotaInformativa${key}`), configuracionCanvas));
      //     promesas.push(html2canvas(document.getElementById(`croquis${key}`), configuracionCanvas));
      //     promesas.push(html2canvas(document.getElementById(`fotosPdf${key}`), configuracionCanvas));
      //     promesas.push(html2canvas(document.getElementById(`fotosPdfFull${key}`), configuracionCanvas));
      //     promesas.push(html2canvas(document.getElementById(`fotosPdfEstructura${key}`), configuracionCanvas));
      //     promesas.push(html2canvas(document.getElementById(`fotosPdfProblema${key}`), configuracionCanvas));
      //   }
      // );
      promesas.push(html2canvas(document.getElementById('portadaEstado'), configuracionCanvas));
      for (let obra of this.keysObras) {
        promesas.push(html2canvas(document.getElementById(`portada${obra.key}`), configuracionCanvas));
        promesas.push(html2canvas(document.getElementById(`pdf${obra.key}`), configuracionCanvas));
        promesas.push(html2canvas(document.getElementById(`pdfNotaInformativa${obra.key}`), configuracionCanvas));
        promesas.push(html2canvas(document.getElementById(`croquis${obra.key}`), configuracionCanvas));
        // if (obra.incluyeImagenes) {
          // promesas.push(html2canvas(document.getElementById(`fotosPdf${obra.key}`), configuracionCanvas));
          // promesas.push(html2canvas(document.getElementById(`fotosPdfFull${obra.key}`), configuracionCanvas));
          // promesas.push(html2canvas(document.getElementById(`fotosPdfEstructura${obra.key}`), configuracionCanvas));
          // promesas.push(html2canvas(document.getElementById(`fotosPdfProblema${obra.key}`), configuracionCanvas));
        // }
      }
      Promise.all(promesas).then(
        (imagenesCanvas: HTMLCanvasElement[]) => {
          imagenesCanvas.forEach(
            (imagenCanvas: HTMLCanvasElement, indice: number) => {
              let imagen: string = imagenCanvas.toDataURL('image/jpeg', 1.0);
              pdf.addImage(imagen, 'JPEG', 0, 0, width, height, undefined, 'FAST');
              if (indice !== imagenesCanvas.length - 1) {
                pdf.addPage();
              }
            }
          );
          pdf.save(`${new Date().getTime()}.pdf`);
        }
      ).catch(
        (error: any) => console.error("Error al ejecutar promesas canvas: ", error)
      ).finally(
        () => {
          this.loaderService.desactivarLoaderScreen();
        }
      );
    } else {
      if (this.obraSeleccionada.obra.incluyeImagenes) {
        this.pdfUtils.descargarCarpetaEjecutivaDeObra(); //SE COMENTA PORQUE NO HAY IMAGENES
        // this.pdfUtils.descargarCarpetaEjecutivaSinImagenes();
      } else {
        this.pdfUtils.descargarCarpetaEjecutivaSinImagenes();
      }
    }
  }

  public abrirModal(obra: ObraDTO, bool: boolean): void {
    this.obraSeleccionada = obra;
    this.boolCarpetaEjecutiva = bool;
    this.modalActivo = this.modalService.open(this.modalCarpetaEjecutiva, { centered: true, size: 'lg', windowClass: 'modal-ficha-tecnica' });
  }

  public abrirModalObras(obras: ObraDTO[], bool: boolean): void {
    this.obras = obras;
    this.boolCarpetaEjecutiva = bool;
    for (let obraIndex of this.obras) {
      var obj = {};
      obj["key"] = obraIndex.obra.key;
      obj["incluyeImagenes"] = obraIndex.obra.incluyeImagenes ? true : false;
      this.keysObras.push(obj);
    }
    this.modalActivo = this.modalService.open(this.modalCarpetaEjecutiva, { centered: true, size: 'lg', windowClass: 'modal-ficha-tecnica' });
  }

  public cerrarModal(): void {
    this.modalActivo.close();
  }

}
